import { render } from "./product-variant-selector.vue?vue&type=template&id=d67e1238"
import script from "./product-variant-selector.vue?vue&type=script&lang=js"
export * from "./product-variant-selector.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__